/**
 * @generated SignedSource<<be314d61277162cd89be35faa1d80e0e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
export type IssueFieldDataType = "DATE" | "MULTI_SELECT" | "NUMBER" | "SINGLE_SELECT" | "TEXT" | "%future added value";
export type IssueTypeColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type useHandleTemplateChangeIssueTemplate$data = {
  readonly __typename: "IssueTemplate";
  readonly __id: string;
  readonly assignees: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename?: "User";
        readonly avatarUrl?: string;
        readonly id?: string;
        readonly login?: string;
        readonly name?: string | null | undefined;
        readonly profileResourcePath?: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  };
  readonly body: string | null | undefined;
  readonly filename: string;
  readonly labels: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly color: string;
        readonly description: string | null | undefined;
        readonly id: string;
        readonly name: string;
        readonly nameHTML: string;
        readonly url: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly name: string;
  readonly title: string | null | undefined;
  readonly type: {
    readonly color: IssueTypeColor;
    readonly description: string | null | undefined;
    readonly id: string;
    readonly isEnabled: boolean;
    readonly name: string;
    readonly pinnedFields: ReadonlyArray<{
      readonly __typename: "IssueFieldDate";
      readonly dataType: IssueFieldDataType;
      readonly id: string;
      readonly name: string;
    } | {
      readonly __typename: "IssueFieldMultiSelect";
      readonly dataType: IssueFieldDataType;
      readonly id: string;
      readonly name: string;
    } | {
      readonly __typename: "IssueFieldNumber";
      readonly dataType: IssueFieldDataType;
      readonly id: string;
      readonly name: string;
    } | {
      readonly __typename: "IssueFieldSingleSelect";
      readonly dataType: IssueFieldDataType;
      readonly id: string;
      readonly name: string;
    } | {
      readonly __typename: "IssueFieldText";
      readonly dataType: IssueFieldDataType;
      readonly id: string;
      readonly name: string;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    }> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useHandleTemplateChangeIssueTemplate";
};
export type useHandleTemplateChangeIssueTemplate$key = {
  readonly " $data"?: useHandleTemplateChangeIssueTemplate$data;
  readonly " $fragmentSpreads": FragmentRefs<"useHandleTemplateChangeIssueTemplate">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "useHandleTemplateChangeIssueTemplate"
};

(node as any).hash = "efc7418bfdb72c2cbcf88995115f84e3";

export default node;
